import { useEffect, useRef, useState } from "react"
import "./index.less"
import { Sensor, DeviceTestConnectHistory } from "@/global/interface/device/sensor"
import { addSensorTestHistory, getSensorTestBySensorId } from "@/api/device/sensor"
import { Spin } from "antd"
import { testSensorConnect } from "@/api/monitoring/monitoring"
import { TEST_RETURN_STATUS } from "@/enums/test-return-status"
import { useParams } from "react-router"
import TnMessage from "@/global/components/message"
import { getDateDetailName } from "@/global/utils/date-utils"

interface Iprops {
    sensor: Sensor
}

export default function SensorCheckPanel(props: Iprops) {

    const [testHistoryList, setTestHistoryList] = useState<DeviceTestConnectHistory[]>([])

    const [isTesting, setIsTesting] = useState<boolean>(false)

    const { projectId } = useParams()

    const { sensor } = props

    useEffect(() => {
        if (sensor) {
            generateData()
        }
    }, [sensor])

    const generateData = () => {
        getSensorTestBySensorId(sensor.id).then(res => {
            let list: DeviceTestConnectHistory[] = res?.data || []
            list.sort((a, b) => a.testTime - b.testTime)
            setTestHistoryList(list)
        })
    }

    const startTest = () => {
        if (!sensor) return
        if (sensor.start) {
            TnMessage.warning("请关闭设备后再进行测试")
            return
        }
        setIsTesting(true)
        testSensorConnect(sensor.id).then(res => {
            let resStatus = res.data
            let detailStr = ""
            if (resStatus == TEST_RETURN_STATUS.SUCESS) {
                detailStr = "通电正常，信号正常，数据正常。"
            } else if (resStatus == TEST_RETURN_STATUS.ERROR_EMPTY_OBJECT) {
                detailStr = "空异常。"
            } else if (resStatus == TEST_RETURN_STATUS.ERROR_CONNECT) {
                detailStr = "未监听到心跳包。"
            } else if (resStatus == TEST_RETURN_STATUS.ERROR_START) {
                detailStr = "启动信号发送失败。"
            } else if (resStatus == TEST_RETURN_STATUS.ERROR_RECIVE) {
                detailStr = "设备通电正常，启动正常，接收失败。"
            }
            let dataStr = getDateDetailName(Date.now())
            // todo 替换为用户名
            let testReocrd = dataStr + "   " + "用户对" + sensor.name + "进行了测试，" + detailStr
            addSensorTestHistory(Number(projectId), sensor.id, { detail: testReocrd }).then(res => {
                generateData()
            })
        }).catch((e) => {
            TnMessage.error("测试失败！")
        }).finally(() => {
            setIsTesting(false)
        })

    }

    return (
        <div className="check-main">
            <div className="title">
                测试
            </div>
            <div className="btn-area">
                {isTesting ? (
                    <div className="loading-area">
                        <Spin />
                    </div>
                ) : (
                    <div className="check-btn" onClick={() => { startTest() }}>
                        开始测试
                    </div>
                )}
            </div>
            <div className="report-list">
                {testHistoryList?.map((item, index) => (
                    <div className="list-item">
                        <div className="label">
                            {"测试记录" + (index + 1)}
                        </div>
                        <div className="value">
                            {item.detail}
                        </div>
                    </div>
                ))}
            </div>

        </div>
    )
}